import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { ASSETS } from "@/data/assets";
import { Check, ArrowRight } from "lucide-react";
import api from "@/lib/apiClient";

const CAT_IMG = {
  "Social Celebrations": ASSETS.mandap,
  "Wedding Sub-services": ASSETS.floral,
  "Corporate": ASSETS.corporate,
  "Production & Design": ASSETS.dining,
};

export default function Services() {
  const { data: services = [], isLoading } = useQuery({ queryKey: ["services"], queryFn: async () => (await api.get("/services")).data });
  const sorted = [...services].sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  return (
    <div data-testid="services-page">
      <section className="relative h-[42vh] min-h-[320px] flex items-end">
        <img src={ASSETS.floral} alt="Event floral decor" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-navy via-brand-navy/60 to-brand-navy/30" />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 pb-12 w-full">
          <p className="overline mb-3">What We Offer</p>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight">Services</h1>
          <p className="mt-4 text-white/75 max-w-xl">Everything your celebration needs, delivered under one roof.</p>
        </div>
      </section>

      <section className="py-20 max-w-7xl mx-auto px-5 sm:px-8 space-y-16">
        {isLoading && <p className="text-brand-ink/60">Loading services…</p>}
        {sorted.map((cat, idx) => (
          <div key={cat.id} data-testid={`service-category-${idx}`} className={`grid lg:grid-cols-2 gap-10 items-center ${idx % 2 ? "lg:[direction:rtl]" : ""}`}>
            <div className="relative h-72 lg:h-96 overflow-hidden rounded-sm [direction:ltr]">
              <img src={CAT_IMG[cat.category] || ASSETS.mandap} alt={cat.category} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-brand-navy/20" />
            </div>
            <div className="[direction:ltr]">
              <p className="overline mb-3">Category</p>
              <h2 className="font-serif text-3xl sm:text-4xl text-brand-navy tracking-tight">{cat.category}</h2>
              <ul className="mt-6 grid sm:grid-cols-2 gap-x-6 gap-y-3">
                {cat.items.map((item) => (
                  <li key={item} className="flex items-center gap-2.5 text-brand-ink/80">
                    <Check size={16} className="text-brand-gold shrink-0" /> <span className="text-sm">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </section>

      <section className="py-16 bg-brand-navy">
        <div className="max-w-3xl mx-auto px-5 text-center">
          <h2 className="font-serif text-3xl sm:text-4xl text-white">Don’t see exactly what you need?</h2>
          <p className="mt-4 text-white/70">We tailor packages to your vision and budget. Let’s talk.</p>
          <Link to="/booking" className="mt-7 inline-flex items-center gap-2 bg-brand-gold text-brand-navy font-semibold px-8 py-3.5 rounded-sm hover:-translate-y-0.5 transition-transform">
            Request a Quote <ArrowRight size={18} />
          </Link>
        </div>
      </section>
    </div>
  );
}
